exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#img{height:180px;object-fit:cover;object-position:0 0}", ""]);

// exports
